import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Navbar, Row } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import auth from '../../libCustom/auth';
import axios from 'axios';
import numeral from 'numeral';
import moment from 'moment';
import logo from '../../assets/img/Icono.png';
class ReportOperatorsIndex extends Component {
  constructor(props) {
    super(props);
    this.sellersList = {
      options: [{ value: 'todos', label: 'Todos' }],
    };
    this.state = {
      data: [],
      formData: {
        date_initial: moment().startOf('month').format('YYYY-MM-DD'),
        date_final: moment().endOf('month').format('YYYY-MM-DD'),
      },

      loading: false,
      dataChart: {
        datasets: [
          {
            label: 'Resumen',
            data: [],
          },
        ],
        labels: [],
      },
      dataTable: {
        nombre: '',
        ventas: '',
        num_ventas: '',
        cotizaciones: '',
        num_cotizaciones: '',
        comisiones: '',
      },
      dataOperators: [],
      titleLoading: 'Cargando...',
    };
  }

  async componentWillMount() {
    this.generateReport();
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  onChange = (data) => {
    this.setState({
      hotelId: data.value,
    });
  };

  onChangeDate = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  generateReport = async () => {
    const _this = this;
    const {
      formData: { date_initial, date_final },
    } = this.state;
    const authUser = auth.getCurrentUser();

    const url = `${process.env.REACT_APP_URL_FEATHERS}/report-operators?franchiseId=${authUser.franchiseId}&dateInit=${date_initial}&dataEnd=${date_final}`;

    this.setState({ loading: false });

    await axios
      .get(url)
      .then(function ({ data }) {
        if (data.length === 0) {
          _this.setState({
            loading: false,
            titleLoading: 'No se encontraron registros',
          });
        } else {
          var itemHotelLabel = [];
          var itemHotelTotal = [];
          data.map(function (item, key) {
            if (key < 10) {
              itemHotelLabel.push(item.name);
              itemHotelTotal.push(item.total);
            }
          });

          var dataCharJS = {
            datasets: [
              {
                label: 'Cantidad',
                data: itemHotelTotal,
                backgroundColor: [
                  'rgb(73,114,177,69)',
                  'rgb(72,156,199,78)',
                  'rgb(68,180,189,74)',
                  'rgb(147,176,55,69)',
                  'rgb(84,99,36,39)',
                  'rgb(176,90,141,69)',
                  'rgb(227,135,70,89)',
                  'rgb(104,163,252,99)',
                  'rgb(46,72,112,44)',
                  'rgb(176,135,55,69)',
                ],
              },
            ],
            labels: itemHotelLabel,
          };

          _this.setState({
            dataOperators: data,
            dataChart: dataCharJS,
            loading: true,
          });
        }
      })
      .catch(function (err) {
        _this.setState({
          loading: false,
          titleLoading: 'Error al consultar información',
        });
      });
  };

  render() {
    let _this = this;
    const {
      titleLoading,
      dataChart,
      loading,
      dataOperators,
      formData: { date_initial, date_final },
    } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Reporte de Operadores '}
                    <div className="header-table">
                      <Navbar.Form className="navbar-search-form">
                        <label style={{ fontWeight: '250' }}>Desde :</label>
                        <input
                          id="date"
                          style={{ color: '#000000' }}
                          type="date"
                          className="form-control"
                          value={date_initial}
                          onChange={(event) =>
                            this.onChangeDate(
                              'date_initial',
                              event.target.value
                            )
                          }
                          name="date"
                        />
                        <label style={{ fontWeight: '250' }}>Hasta :</label>
                        <input
                          id="date2"
                          style={{ color: '#000000' }}
                          type="date"
                          className="form-control"
                          value={date_final}
                          onChange={(event) =>
                            _this.onChangeDate('date_final', event.target.value)
                          }
                          name="date2"
                        />
                        <Button
                          onClick={_this.generateReport}
                          style={{
                            backgroundColor: '#69a900',
                            border: '#69a900',
                            color: '#fff',
                            fontWeight: '500',
                            width: '150px',
                            marginLeft: '15px',
                          }}
                        >
                          Generar
                        </Button>
                        {(auth.can('support') || auth.can('matriz')) && (
                          <Button
                            href={`${process.env.REACT_APP_URL_FEATHERS}/operators-franchise-report/?startDate=${date_initial}&endDate=${date_final}`}
                            style={{
                              backgroundColor: '#69a900',
                              border: '#69a900',
                              color: '#fff',
                              fontWeight: '500',
                              width: '250px',
                              marginLeft: '15px',
                            }}
                          >
                            Descargar Reporte Operadores
                          </Button>
                        )}
                      </Navbar.Form>
                    </div>
                  </div>
                }
                ctFullWidth
                content={
                  <div>
                    {loading ? (
                      <Bar
                        loading={loading}
                        ref="chart"
                        height={80}
                        redraw={true}
                        data={dataChart}
                      />
                    ) : (
                      <h4
                        style={{
                          textAlign: 'center',
                          marginTop: '85px',
                          marginBottom: '85px',
                        }}
                      >
                        {titleLoading}
                      </h4>
                    )}
                  </div>
                }
              />

              {loading ? (
                <div>
                  <img
                    src={logo}
                    style={{ height: '40px', marginBottom: '10px' }}
                    alt="logo"
                  ></img>
                  <span
                    style={{
                      fontSize: '20px',
                      color: '#000',
                      fontWeight: '100',
                    }}
                  >
                    Informe de Operadores
                  </span>
                  <div className="containerTable">
                    <table>
                      <thead>
                        <tr>
                          <th>Hotel</th>
                          <th width={345}>Costo</th>
                          <th width={245}>Cantidad</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataOperators.map(function (item, key) {
                          return (
                            <tr key={key}>
                              <td>{item.name}</td>
                              <td>{numeral(item.total).format('$0,00.00')}</td>
                              <td>{item.count}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : null}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ReportOperatorsIndex;



// WEBPACK FOOTER //
// ./src/views/ReportOperators/ReportIndex.js